import { useState } from "react";
import { Loader2 } from "lucide-react";
import { appsApi, errMsg, inputCls, btnDark } from "@/lib/appsApi";

export const AppsReset = ({ token, onDone }) => {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords don't match.");
    setBusy(true);
    setError("");
    try {
      await appsApi.post("/auth/reset", { token, password: pw });
      onDone("Password set. You can now sign in.");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
    return undefined;
  };

  return (
    <form onSubmit={submit} data-testid="apps-reset-form">
      <h2 className="font-display text-3xl font-semibold tracking-tight text-ink">Choose a password</h2>
      <p className="mt-2 text-sm text-slate-600">At least 8 characters.</p>
      <div className="mt-8 space-y-4">
        <input type="password" required minLength={8} placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className={inputCls} data-testid="apps-reset-password" />
        <input type="password" required minLength={8} placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={inputCls} data-testid="apps-reset-confirm" />
      </div>
      {error && <p className="mt-4 text-sm text-red-600" data-testid="apps-reset-error">{error}</p>}
      <button type="submit" disabled={busy} className={`${btnDark} mt-6 w-full`} data-testid="apps-reset-submit">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Save password
      </button>
    </form>
  );
};
